module.exports = __webpack_public_path__ + "img/SI5023912.dcd9f8d3.png";